const IntakeSegmentPreviewTestIdsScope = {
  INTAKE_SEGMENT_PREVIEW: 'intake-segment-preview',
};

export const IntakeSegmentPreviewTestIds = {
  ZOOM_OUT_BUTTON: `${IntakeSegmentPreviewTestIdsScope.INTAKE_SEGMENT_PREVIEW}.zoom-out-button`,
  ZOOM_IN_BUTTON: `${IntakeSegmentPreviewTestIdsScope.INTAKE_SEGMENT_PREVIEW}.zoom-in-button`,
  ROTATE_BUTTON: `${IntakeSegmentPreviewTestIdsScope.INTAKE_SEGMENT_PREVIEW}.rotate-button`,
  CLOSE_BUTTON: `${IntakeSegmentPreviewTestIdsScope.INTAKE_SEGMENT_PREVIEW}.close-button`,
};
